import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "./wtStyle";

const TONE_COLOR = {
  blue: COLORS.blue,
  orange: COLORS.orange,
  red: COLORS.red,
  green: COLORS.green,
  grey: "#111827",
};

// CP-Sourcing-style stat row ("All My CPs 474 / Outreach 58 / Escalate 85 /
// Critical 195 / Never Active 0") ported to Work Transfer — same shape
// (count + label + optional hint, colored by tone), reused for both the
// "Who's work is moving" overview and the per-user dormancy breakdown so the
// two rows read as one system instead of two different designs.
export default function InsightTiles({ tiles }) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 1.25, mb: 2 }}>
      {tiles.map((tile, i) => (
        <Box
          key={i}
          sx={{
            border: `1px solid ${COLORS.border}`,
            borderRadius: 2.5,
            p: 1.5,
            bgcolor: "#fff",
          }}
        >
          <Typography fontSize={21} fontWeight={700} lineHeight={1.1} sx={{ color: TONE_COLOR[tile.tone] || TONE_COLOR.grey, fontVariantNumeric: "tabular-nums" }}>
            {tile.count}
          </Typography>
          <Typography fontSize={12} fontWeight={600} sx={{ mt: 0.4 }}>
            {tile.label}
          </Typography>
          {tile.hint && (
            <Typography fontSize={11} color={COLORS.textSecondary} sx={{ mt: 0.1 }}>
              {tile.hint}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
